<template>
  <component-wrapper>
    <grid-container-fi>
      <div class="newsroom-detail-fi__content">
        <headline-fi
          :field="fields.subheadline"
          class="newsroom-detail-fi__overheadline"
          :size="30"
        />
        <headline-fi
          class="newsroom-detail-fi__headline"
          :size="60"
          :field="fields.headline"
        />

        <div class="newsroom-detail-fi__date-container">
          <span
            v-if="date"
            class="badge-fi newsroom-detail-fi__date"
          >
            {{ date }}
          </span>

          <div class="newsroom-detail-fi__location">
            {{ fields?.location?.value }}
          </div>
        </div>

        <richtext-fi
          class="newsroom-detail-fi__text"
          :html-content="fields.text"
        />
      </div>
    </grid-container-fi>

    <newsroom-contact-persons-fi
      class="newsroom-detail-fi__contact-persons"
      :contact-persons="fields?.contact"
      :link="fields?.link"
    />

    <template v-if="fields?.images?.length > 0">
      <section-divider-small-fi />

      <grid-container-fi :container="false">
        <div class="fi-col-span-full">
          <newsroom-media-slider-fi />
        </div>
      </grid-container-fi>
    </template>
  </component-wrapper>
</template>

<script>
import { HeadlineFi, RichtextFi } from 'atoms';
import ComponentWrapper from 'components/component-wrapper/ComponentWrapper';
import GridContainerFi from 'components/grid-fi/GridContainerFi';
import NewsroomContactPersonsFi from 'components/newsroom-contact-person-fi/NewsroomContactPersonsFi';
import NewsroomMediaSliderFi from 'components/newsroom-media-slider-fi/NewsroomMediaSliderFi';
import SectionDividerSmallFi from 'pages/section-divider-fi/SectionDividerSmallFi';

export default {
  name: 'NewsroomDetailFi',
  components: {
    ComponentWrapper,
    GridContainerFi,
    SectionDividerSmallFi,
    HeadlineFi,
    RichtextFi,
    NewsroomContactPersonsFi,
    NewsroomMediaSliderFi,
  },
  inject: ['fields'],
  props: {
    customData: {
      type: Object,
      default: null,
    },
  },
  computed: {
    date() {
      let date = IS_SHOWROOM ? '2023-10-23T18:25:43.511Z' : this.customData?.pressDate;

      if (!date) {
        return null;
      }

      date = new Date(date);

      return date.toLocaleDateString();
    },
  },
};
</script>

<style lang="scss" scoped>
@import './newsroom-detail-fi';
</style>
